import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQSection from '../components/FAQSection';
import CTABanner from '../components/CTABanner';

const FAQPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>FAQ - WorkNation Labour Ltd | Staffing Questions Answered</title>
        <meta name="description" content="Frequently asked questions about WorkNation Labour Ltd staffing services. Find answers for employers and job seekers about hiring, registration, pay, WCB compliance, and more in British Columbia." />
        <link rel="canonical" href="https://worknation.ca/faq" />
      </Helmet>
      <Header />
      <main>
        <div className="pt-28 pb-4 px-6 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#003366] mb-4">Frequently Asked Questions</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Everything you need to know about working with WorkNation Labour Ltd. Can&apos;t find your answer? Contact us directly.
            </p>
          </div>
        </div>
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
};

export default FAQPage;
